module.exports = __webpack_public_path__ + "static/img/ID_card.7a7e430f.jpg";